import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import * as models from 'app/models';
import * as services from 'app/services';

@Component({
    selector: 'app-team-edit',
    templateUrl: './team-edit.component.html',
    styleUrls: ['./team-edit.component.scss'],
    standalone: false
})
export class TeamEditComponent {

  team: models.Team;
  adding: boolean;
  saveClick: boolean = false;

  get memberCount(): number {
    return this.team.userIds?.length || 0;
  }

  constructor(
    private dialogRef: MatDialogRef<TeamEditComponent>
    , private teamService: services.TeamService
    , private helperService: services.HelperService
    , private notifierService: services.NotifierService
    , @Inject(MAT_DIALOG_DATA) public data: models.Team
  ) {
    this.adding = data == null || data.uid == null;
    this.team = this.adding ? { name: '', userIds: [] } : this.helperService.deepCopy(data);
    if (this.team.userIds == null) {
      this.team.userIds = [];
    }
  }

  async save() {
    let name = (this.team.name || '').trim();
    if (name.length === 0) {
      this.notifierService.error('Team name is required.');
      return;
    }

    this.saveClick = true;

    //only send the fields that live on the document - enriched fields stay out of firestore
    let team: models.Team = {
      name: name,
      userIds: this.team.userIds || []
    };

    try {
      if (this.adding) {
        await this.teamService.add(team);
      } else {
        team.uid = this.team.uid;
        await this.teamService.update(team);
      }

      this.notifierService.success(`Successfully ${this.adding ? 'added' : 'updated'} Team`);
      this.dialogRef.close(true);
    } catch (error) {
      this.notifierService.error('Unable to save the Team.  Please try again.');
      this.saveClick = false;
    }
  }
}
